import { useEffect } from "preact/hooks"
import { useAppStateSelector } from "./useAppStateSelector"

/**
 * A hook that dispatches an event on component load/update.
 * @example
 * useDispatchEventOnLoad("nosto:ns-serp", { sectionId: "ns-serp" });
 *
 * return (
 *     <div
 *         class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-p-4 ns-my-0 ns-mx-auto"
 *         data-nosto-element="search"
 *     >
 *         // Your content here
 *     </div>
 * );
 * @param type - event name
 * @param payload - event payload
 * @param context - event target, default window
 * @group Hooks
 */
export function useDispatchEventOnLoad(
    type: string,
    payload: Record<string, string> = {},
    context: EventTarget = window
) {
    const products = useAppStateSelector(state => state.response.products)

    useEffect(() => {
        const event = new CustomEvent(type, {
            detail: payload
        })

        context.dispatchEvent(event)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [products])
}
